import React, { Component } from 'react';
import { Row, Col, Card, Container, Form, ButtonGroup, Button, Table } from 'react-bootstrap';
import * as Cookies from "es-cookie";
import '../_exam_made_easy.scss';
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { Link, withRouter } from 'react-router-dom';
import parse, { domToReact } from 'html-react-parser';
import { Scrollbars } from 'react-custom-scrollbars'

const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
        borderRadius: 6,
        width: '3px',
        backgroundColor: 'rgba(0, 0, 0, 0.1)'
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
};
class EditQuestionSelectedDetails extends Component {
    constructor(props) {
        super(props)

        this.state = {


        }
    }

    examTypeName = (value) => {
        let examTypeName = "";

        if (value == "1") {
            examTypeName = "NEET"
        } else if (value == "2") {
            examTypeName = "JEE"
        } else if (value == "3") {
            if (this.props.stateData.eamcetExamType == "3") {
                examTypeName = "AP-EAMCET-MPC"
            } else {
                examTypeName = "AP-EAMCET-BiPC"
            }
        }

        return examTypeName;
    }

    OpenQuestions = (e, questions) => {
        console.log("questions", "aravindddd");
        console.log("helllllll", questions);
        this.props.pselecthandleInputChange("qbQuestionSearchSubject", questions.subjectId);
        let checkedTopicArr = [];

        setTimeout(() => {
            this.props.pselecthandleInputChange("qbsearchchapter", questions.id);

            questions.topics.map((topic, index) => {
                var obj = {
                    label: topic.topic_name,
                    value: topic.id
                }
                checkedTopicArr.push(obj);
                this.props.stateData.selectedTopicIdsArr.push(topic.topic);
            })

            console.log("checkedTopicArr", checkedTopicArr)

            this.props.handleMultipleSelectInputChange(checkedTopicArr, "topic");
            this.props.pselecthandleInputChange("typeOfQuestion", "7");
        }, 500);

        setTimeout(() => {
            this.props.ponScrollgetQuestionById();
        }, 1500);


    }


    getDraftQuestions = () => {
        let array2 = [];
        this.props.stateData.subjects.map((item) => {
            item.chapters.map((chdata) => {
                if (chdata.questionbarray.length > 0) {
                    let object = { ...chdata, subjectId: item.id };
                    array2.push(object);
                }
            });
        });
        return array2;
    }

    render() {
        console.log("this.props.stateData.questionbank_checked", this.props.stateData)


        return (
            <div className='exam_made_easy'>
                <Row>
                    <Col sm={12}>
                        <Table className="question_selection_details table-borderless">
                            <tbody>
                                <tr>
                                    <th>Exam Type </th>
                                    <th>: {this.examTypeName(this.props.stateData.exam_type)} </th>
                                </tr>
                                {this.props.stateData.exam_type != "" ? (
                                    <React.Fragment>
                                        {this.props.stateData.exam_type == "1" ? (
                                            <React.Fragment>
                                                {
                                                    this.props.stateData.pattern_type == "0" ? (
                                                        <React.Fragment>
                                                            <tr>
                                                                <th> Duration </th>
                                                                <th>: 180 Min </th>
                                                            </tr>
                                                            <tr>
                                                                <th>Total No Of Questions </th>
                                                                <th>: 180</th>
                                                            </tr>
                                                        </React.Fragment>
                                                    ) : this.props.stateData.pattern_type == "1" ? (

                                                        <React.Fragment>
                                                            <tr>
                                                                <th> Duration </th>
                                                                <th>: 180 Min </th>
                                                            </tr>
                                                            <tr>
                                                                <th>Total No Of Questions </th>
                                                                <th>: 200</th>
                                                            </tr>
                                                        </React.Fragment>
                                                    )
                                                        : (
                                                            <React.Fragment>
                                                                <tr>
                                                                    <th> Duration </th>
                                                                    <th>: Custom </th>
                                                                </tr>
                                                                <tr>
                                                                    <th>Total No Of Questions </th>
                                                                    <th>: Custom</th>
                                                                </tr>
                                                            </React.Fragment>
                                                        )
                                                }

                                            </React.Fragment>
                                        ) : this.props.stateData.exam_type == "3" || this.props.stateData.exam_type == "6" || this.props.stateData.exam_type == "7" || this.props.stateData.exam_type == "8" ? (
                                            <React.Fragment>
                                                <tr>
                                                    <th> Duration </th>
                                                    <th>: Custom </th>
                                                </tr>
                                                <tr>
                                                    <th>Total No Of Questions </th>
                                                    <th>: Custom</th>
                                                </tr>
                                            </React.Fragment>
                                        ) : (

                                            <React.Fragment>
                                                {this.props.stateData.exam_type == "2" ? (
                                                    <React.Fragment>
                                                        {
                                                            this.props.stateData.jee_pattern_type == "0" ?
                                                                (
                                                                    <React.Fragment>
                                                                        <tr>
                                                                            <th> Duration </th>
                                                                            <th>: 180 Min </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Total No Of Questions </th>
                                                                            <th>: 75</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th> General Questions </th>
                                                                            <th>: 20 Q</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Integer Questions </th>
                                                                            <th>: 5 Q</th>
                                                                        </tr>
                                                                    </React.Fragment>
                                                                ) : this.props.stateData.jee_pattern_type == "1" ? (
                                                                    <React.Fragment>
                                                                        <tr>
                                                                            <th> Duration </th>
                                                                            <th>: 180 Min </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Total No Of Questions </th>
                                                                            <th>: 90</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>General Questions</th>
                                                                            <th>: 20 Q</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Integer Questions </th>
                                                                            <th>: 10 Q</th>
                                                                        </tr>
                                                                    </React.Fragment>

                                                                ) : (
                                                                    <React.Fragment>
                                                                        <tr>
                                                                            <th> Duration </th>
                                                                            <th>: Custom </th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Total No Of Questions </th>
                                                                            <th>: Custom</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>General Questions</th>
                                                                            <th>: Custom</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Integer Questions </th>
                                                                            <th>: Custom</th>
                                                                        </tr>
                                                                    </React.Fragment>
                                                                )
                                                        }

                                                    </React.Fragment>) : (
                                                    <React.Fragment>
                                                        <tr>
                                                            <th> Duration </th>
                                                            <th>: 300 Min </th>
                                                        </tr>
                                                        <tr>
                                                            <th>No Of Questions </th>
                                                            <th>: 75</th>
                                                        </tr>
                                                    </React.Fragment>)}

                                            </React.Fragment>
                                        )}
                                    </React.Fragment>
                                ) : ("")}



                            </tbody>
                        </Table>
                    </Col>
                    <Col sm={12}>
                        <Scrollbars style={{ height: "40vh" }}
                            {...this.props}
                            renderThumbVertical={renderThumb}
                            autoHide
                            autoHideTimeout={500}
                            autoHideDuration={200}>
                            {this.props.stateData.subjects.map((subjectmapData) => (
                                <React.Fragment>{subjectmapData.checked == true ? (
                                    <Card className="border-0 bg-light">
                                        <Card.Header className="bg-secondary">
                                            <Card.Title className="mb-0 text-white f-14">{subjectmapData.subject}</Card.Title>
                                        </Card.Header>
                                        <Card.Body className="p-3">
                                            <Scrollbars style={{ height: "120px" }}
                                                {...this.props}
                                                renderThumbVertical={renderThumb}
                                                autoHide
                                                autoHideTimeout={500}
                                                autoHideDuration={200}>
                                                {subjectmapData.chapters.map((chaptermapData) => {
                                                    let topiccount = "";
                                                    if (chaptermapData.checked == true) {
                                                        topiccount = chaptermapData.topics.filter((b) => b.checked == true)
                                                    }
                                                    return (
                                                        <React.Fragment>{chaptermapData.checked == true ? (
                                                            <Card className="single-list-card border-0 p-2">
                                                                <Card.Title className="h6">{chaptermapData.chapter}-{topiccount.length}</Card.Title>
                                                                <ul className="list-unstyled topic-list bg-light m-0">
                                                                    {chaptermapData.topics.map((topicmapData) => (
                                                                        <React.Fragment>{topicmapData.checked == true ? (<li>{topicmapData.topic}</li>) : ("")}</React.Fragment>
                                                                    ))}
                                                                </ul>
                                                            </Card>) : ("")}</React.Fragment>
                                                    )
                                                })}
                                            </Scrollbars>
                                        </Card.Body>
                                    </Card>) : ("")}</React.Fragment>
                            ))}

                            {this.props.stateData.generate_type == "2" ? (
                                <React.Fragment>
                                    {this.props.stateData.questionbank_checked == true ? (
                                        <Card className="border-0 bg-light mb-2">
                                            <Card.Header className="bg-secondary">
                                                <Card.Title className="h6 mb-0 text-white">Question Bank Added Questions</Card.Title>
                                            </Card.Header>
                                            <Card.Body className="p-3">
                                                <ul className="list-unstyled chapter-list chapter-list-cursor bg-light m-0">
                                                    {this.getDraftQuestions().map((chaptermapdata) => {
                                                        //if (chaptermapdata.questionbarray.length > 0) {
                                                        return (<li onClick={(e) => this.OpenQuestions(e, chaptermapdata)}>{chaptermapdata.chapter}-{chaptermapdata.questionbarray.length}</li>)
                                                        //}
                                                    })}
                                                </ul>
                                            </Card.Body>
                                        </Card>
                                    ) : ("")}
                                </React.Fragment>
                            ) : ("")}

                        </Scrollbars>
                    </Col>
                </Row>

                <hr className='mt-0' />
                <Row>
                    {
                        this.props.stateData.generate_type == "2" ?
                            (
                                <Col sm={12} className='mt-3'>
                                    <Button type="button" className="btn btn-light-blue center-auto" onClick={(e) => this.props.showQuestionGenerateModal(e, "draft")}>Save Draft</Button>
                                </Col>
                            )
                            :
                            ("")
                    }
                    <Col sm={12} className='mt-3'>
                        <Button type="button" className="btn btn-orange center-auto" onClick={(e) => this.props.showQuestionGenerateModal(e, "save")}>Generate </Button>
                    </Col>
                </Row>
            </div>

        )
    }
}


export default withRouter(withApollo((EditQuestionSelectedDetails)));


